'use client';

import { Accordion } from '@ngg/components';

import { formatPrice } from '@/utils/priceUtils';

import Icon from './icon';

export default function HistoricalPrice({
    locale,
    className,
    originalPrice,
    priceType,
    historicalPrices,
    historicalPricesTitle,
}: {
    locale?: string;
    className?: string;
    originalPrice?: number;
    priceType?: string;
    historicalPrices: string;
    historicalPricesTitle: string;
}) {
    if (!originalPrice) return null;
    const formattedPrice = formatPrice(originalPrice, locale);
    if (!formattedPrice) return null;
    if (priceType !== 'campaign') return null;
    return (
        <Accordion
            title={historicalPricesTitle}
            IconComponent={Icon}
            WrapperComponent="div"
            transitionProps={{ appear: false }}
            classNames={{
                wrapper: className,
                button: 'text-left items-center leading-4 p-4 font-medium rounded-none',
                panel: 'p-4',
            }}
            defaultOpen>
            <p className="text-sm">
                {historicalPrices.replace('%PRICE%', formattedPrice)}
            </p>
        </Accordion>
    );
}
